import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../store/auth";

export default function ProtectedRoute({ children }) {
  const { status, bootstrap } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (status === "idle") {
      bootstrap();
    }
  }, [status, bootstrap]);

  if (status === "idle" || status === "loading") {
    return (
      <div data-testid="auth-loading" className="flex h-screen items-center justify-center text-muted-foreground">
        Cargando...
      </div>
    );
  }

  if (status === "unauthenticated") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
